import { createAction } from 'redux-actions';

export const setAnnotationDisplayOption = createAction(
  'SET_ANNOTATION_DISPLAY_OPTION',
);

export const resetAnnotationDisplayAndPositionOption = createAction(
  'RESET_ANNOTATION_DISPLAY_AND_POSITION_OPTION',
);
